var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallCursorClick = function SvgSmallCursorClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.5 1.75V1M2.53 2.53 2 2m.53 4.5L2 7.03m4.5-4.5L7.03 2M1.75 4.5H1m6.932 3.595-1.246 2.313c-.142.265-.213.397-.299.43a.25.25 0 0 1-.225-.022c-.078-.049-.122-.193-.21-.48l-1.73-5.613c-.072-.235-.108-.352-.079-.431a.25.25 0 0 1 .149-.149c.08-.029.196.007.43.08l5.615 1.729c.287.088.43.132.48.21a.25.25 0 0 1 .021.225c-.033.086-.165.157-.43.3L8.095 7.931c-.04.021-.06.032-.076.046a.3.3 0 0 0-.041.04c-.014.018-.025.038-.046.077"
  })));
};
export default SvgSmallCursorClick;